//@ts-nocheck
import React, { Fragment } from "react";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types"
// import { AppToolbar, Breadcrumbs, Snackbar } from "@nokia-csf-uxr/ccfk";
// import {
//   Breadcrumb,
//   BreadcrumbCompacts,
//   BreadcrumbCompactsHeader,
//   BreadcrumbIcon,
//   LinkSeparator
// } from "@nokia-csf-uxr/ccfk/Breadcrumbs";
import breadcrumIcon from '../../../Assets/Icons/breadcrum_icon.svg'
import NeutralIcon from '../../../Assets/Icons/Neutral.svg'
//@ts-ignore
const BreadCrum = ({ items, separator = '>' }) => {
  // console.log(items, 'itemssss')
  
  const handleLinkClick = (item) => {
    // Only execute callback if back icon is present AND callback function exists
    if (item.backIcon === true && typeof item.onBackClick === 'function') {
      item.onBackClick();
    }
  };

  return (
    <div data-testid="breadcrumbs">
      {items.length !== 0 && (
        items.map((item, index) => (
          <React.Fragment key={index}>
            {item.path !== '' ? 
              <Link 
                style={{textDecoration: 'none', color: '#000', fontSize: '16px', fontWeight: 400}} 
                to={item.path}
                title={item.fullTitle || item.title} // Add title attribute for tooltip
                onClick={(e) => {
                  if (item.onClick) {
                    e.preventDefault();
                    item.onClick();
                  } else if (item.backIcon && item.onBackClick) {
                    handleLinkClick(item);
                  }
                }}
              > 
                { item.backIcon ? <img src={NeutralIcon} style={{display: "inline-block", verticalAlign: "middle",marginInlineEnd:'10px'}}/> : "" } 
                {item.title}
              </Link> : 
              <span 
                style={{textDecoration: 'none', color: '#000', fontSize: '16px', fontWeight: 400}}
                title={item.fullTitle || item.title} // Add title attribute for tooltip
              >
                {item.title}
              </span>
            }
            {index < items.length - 1 && <span style={{marginLeft: '.7rem', marginRight: '.7rem'}}><img src={breadcrumIcon}/></span>}
          </React.Fragment>
        ))
      )}
    </div>

    
  );
}

  export default BreadCrum;

  BreadCrum.propTypes = {
    items : PropTypes.array,
    separator:PropTypes.any
  }